import {
  RiskSeverity,
  RiskStatus,
  RiskStatusLabel,
  SeverityDef,
} from '@/types';

const getRiskStatus = (status: string = '') => {
  const slicedStatus = status.slice(0, 1);

  if (Object.values(RiskStatus).includes(slicedStatus as RiskStatus)) {
    return slicedStatus as RiskStatus;
  }

  return '' as RiskStatus;
};

const getRiskSeverity = (status: string = '') => {
  const slicedSeverity = status[1];

  if (Object.values(RiskSeverity).includes(slicedSeverity as RiskSeverity)) {
    return slicedSeverity as RiskSeverity;
  }

  return '' as RiskSeverity;
};

export const getRiskStatusLabel = (riskStatus: NonNullable<string>) => {
  const status = getRiskStatus(riskStatus);
  const severity = getRiskSeverity(riskStatus);

  return {
    status,
    severity,
    statusLabel: RiskStatusLabel[status],
    severityLabel: SeverityDef[severity],
  };
};

/**
 * A finding is DEMONSTRATED when it is Open (status code `O`) AND its severity
 * is not an Exposure (`E`). This is the single predicate gating customer-facing
 * retest affordances — Open exposures are not retestable findings.
 */
export const isDemonstrated = (riskStatus: string): boolean => {
  const { status, severity } = getRiskStatusLabel(riskStatus ?? '');
  return status === RiskStatus.Opened && severity !== RiskSeverity.Exposure;
};
